const s = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_API_URL: "https://api.focusdive.app", VITE_APP_URL: "https://focusdive.app", VITE_DEBUG: "false", VITE_SENTRY_DSN: "https://1208b9062b0c9ff82eae8df609baea00@o4509393812848640.ingest.de.sentry.io/4509393909055568", VITE_SLACK_CLIENT_ID: "8653557958449.8628089266455" }, e = (i, n) => {
  const r = s[i]?.trim();
  if (!r) {
    if (n !== void 0)
      return n;
    throw new Error(`Missing required environment variable: ${i}`);
  }
  return r;
}, o = e("VITE_API_DOMAIN", "api.focusdive.app"), a = () => typeof window > "u" ? e("VITE_APP_URL", "") : e("VITE_APP_URL", window.location.origin), t = {
  apiDomain: o,
  apiUrl: e("VITE_API_URL", `https://${o}`),
  appUrl: e("VITE_APP_URL", a()),
  isDebug: e("VITE_DEBUG", "false").toLowerCase() === "true",
  slackClientId: e("VITE_SLACK_CLIENT_ID", ""),
  sentryDsn: e("VITE_SENTRY_DSN", "")
}, _ = `${t.appUrl}/slack/connect`, c = `https://slack.com/oauth/v2/authorize?user_scope=dnd:write,users.profile:write,users:write&client_id=${t.slackClientId}&redirect_uri=${encodeURIComponent(_)}`, {
  apiDomain: p,
  apiUrl: l,
  appUrl: I,
  isDebug: E,
  slackClientId: d,
  sentryDsn: u
} = t;
export {
  p as apiDomain,
  l as apiUrl,
  I as appUrl,
  _ as configSlackRedirectUri,
  t as default,
  E as isDebug,
  u as sentryDsn,
  c as slackAuthUrl,
  d as slackClientId
};
